import axios from "axios";

const cartModule = {
    namespaced: true,
    state: {
      count: 0,
      config: null,
      items: {},
      mzItems: {}
    },
    getters: {
      getCount(state) {
        return state.count;
      },
      getConfig(state) {
        return state.config;
      },
      getItems(state) {
        return state.items;
      },
      getMzItems(state) {
        return state.mzItems;
      },
      getAcceptanceIdByItemId: (state) => (id) => {
        return state.items[id] ? state.items[id].acceptance_id : "";
      },
      getEmptyAcceptanceIdItemsLength(state) {
        return Object.keys(state.items).filter(item => !state.items[item].acceptance_id).length;
      }
    },
    actions: {
      fetchCart({commit, dispatch}) {
        axios.get('/api/cart')
          .then((response) => {
            dispatch('clearCount');
            commit('setCount', Object.keys(response.data.items).length);
            dispatch('clearMzItems');
            dispatch('setMzItems', response.data.items);
          });
      },
      fetchCartConfig({commit, dispatch}) {
        axios.get('/api/cart/config')
          .then((response) => {
            dispatch('clearCartConfig');
            commit('setConfig', response.data);
          });
      },
      setCount({commit}, count) {
        commit('setCount', count);
      },
      setConfig({commit}, config) {
        commit('setConfig', config);
      },
      setItems({commit}, items) {
        commit('setItems', items);
      },
      setItemAcceptanceId({commit}, {id, acceptanceId}) {
        commit('setItemAcceptanceId', {id, acceptanceId});
      },
      setItemMzGrantFileId({commit}, {id, mzGrantFileId}) {
        commit('setItemMzGrantFileId', {id, mzGrantFileId});
      },
      setMzItems({commit}, items) {
        let mzItems = {};
        Object.keys(items).filter(e => items[e].mz_grant_file_id).map((e) => {
          mzItems[e] = {
            "mz_grant_file_id": items[e].mz_grant_file_id,
            "material_type": items[e].material_type,
          }
        });
        commit('setMzItems', mzItems);
      },
      clearCount({commit}) {
        commit('setCount', 0);
      },
      clearCartConfig({commit}) {
        commit('setConfig', null);
      },
      clearItems({commit}) {
        commit('setItems', {});
      },
      clearMzItems({commit}) {
        commit('setMzItems', {});
      }
    },
    mutations: {
      setCount(state, count) {
        state.count = count;
      },
      setConfig(state, config) {
        state.config = config;
      },
      setItems(state, items) {
        state.items = items;
      },
      setItemAcceptanceId(state, {id, acceptanceId}) {
        state.items[id].acceptance_id = acceptanceId;
      },
      setItemMzGrantFileId(state, {id, mzGrantFileId}) {
        state.items[id].mz_grant_file_id = mzGrantFileId;
      },
      setMzItems(state, mzItems) {
        state.mzItems = mzItems;
      }
    }
  }

  export default cartModule;